/** @file pixelFit: the largest even target size whose upscaled CSS size is a whole number of CSS pixels. */

/** How far below the top size the search looks before it gives up and returns the top size. */
const SEARCH_PX = 64;

/** True when `x` is a whole number within float noise. */
const whole = (x: number): boolean => Math.abs(x - Math.round(x)) < 1e-9;

/**
 * Largest even size `n <= devicePx / scale` with `n * scale / dpr` a whole number of CSS pixels, so the canvas lands
 * on whole device pixels at any devicePixelRatio; searched `SEARCH_PX` down, else the top even size.
 */
export function pixelFit(devicePx: number, scale: number, dpr: number): number {
  const top = Math.max(2, 2 * Math.floor(devicePx / scale / 2));
  for (let n = top; n >= Math.max(2, top - SEARCH_PX); n -= 2) {
    if (whole((n * scale) / dpr)) return n;
  }
  return top;
}
